import { getModuleById } from "@/lib/ModuleUtils"

export function validatePageRights(id, rights = []) {
    let hasRights = false
    const MODULE = getModuleById(id)

    if (!MODULE) return false
    if (rights.includes(MODULE.right)) return true
    return false
}
